const validateAgencyName = ({ agencyName = '' }) => {
  if (agencyName.length < 1) {
    return 'Agency Name is required.';
  }

  return '';
};

const validate = (values = {}) => validateAgencyName(values);

export default validate;
